import React from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@tiny/components";
import {
  toChipColor,
  toChipText,
} from "../SuppressionList/SuppressionListRow/SuppressionListRow.helper";
import { FindEmailDialogProps } from "./FindEmailDialog.types";
import { useFindEmailDialog } from "./FindEmailDialog.hooks";
import { useStyles } from "./FindEmailDialog.styles";

function FindEmailDialog({ open, onClose }: FindEmailDialogProps) {
  const classes = useStyles();
  const { email, setEmail, results, isLoading, onSearch, onReset } =
    useFindEmailDialog();

  const handleClose = React.useCallback(() => {
    onReset();
    onClose();
  }, [onClose, onReset]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle onClose={handleClose}>Find Customer</DialogTitle>
      <DialogContent>
        <div className={classes.searchRow}>
          <TextField
            value={email}
            placeholder="Enter Suppressed Email"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === "Enter") onSearch();
            }}
            size="small"
            className={classes.emailInput}
            autoFocus
          />
          <Button
            variant="contained"
            color="primary"
            onClick={onSearch}
            loading={isLoading}
            disabled={!email.trim() || isLoading}
          >
            Search
          </Button>
        </div>
        {results !== null && (
          <div className={classes.results}>
            {results.length === 0 ? (
              <Typography
                variant="body2"
                color="grey"
                tone={600}
                className={classes.emptyText}
              >
                This email is not suppressed in any list.
              </Typography>
            ) : (
              <ul className={classes.list}>
                {results.map((result, index) => (
                  <li key={index} className={classes.item}>
                    <Typography variant="label1" color="grey" tone={900}>
                      {result.suppressionName}
                    </Typography>
                    <Chip
                      label={toChipText(result.suppressionScope)}
                      color={toChipColor(result.suppressionScope)}
                      size="small"
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default FindEmailDialog;
